import { AnimationDuration } from "@uno/protocol";
import { AnimationValue } from "../types/Animation";
import { getDiscardRotation } from "./utils";
import { getScales } from "utils/CardScale";

const FromRoomPlayerHandToDiscardAnimation = (playerId: string, index: number, positionInDiscardStack: number): AnimationValue => {
    const discard = document.querySelector("#discard-container");
    const origin = document.querySelector(`[data-player-id="${playerId}"]`);
    const card = origin?.querySelectorAll(".card-container")[index];
    const placeholder = discard?.querySelector("#card-placeholder");

    if(!discard || !origin || !card || !placeholder) {
        return { initial: {}, effects: [], transitions: [], duration: 0 };
    }

    const placeholderRect = placeholder.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    const rotation = getDiscardRotation(positionInDiscardStack);
    const cardTransform = getComputedStyle(card).transform;
    const { e: offsetX, f: offsetY } = cardTransform === "none" ? new DOMMatrixReadOnly() : new DOMMatrixReadOnly(cardTransform);

    const deltaX = (placeholderRect.left + placeholderRect.width / 2) - (cardRect.left + cardRect.width / 2) + offsetX;
    const deltaY = (placeholderRect.top + placeholderRect.height / 2) - (cardRect.top + cardRect.height / 2) + offsetY;

    return {
        initial: { zIndex: 100 },
        effects: [{
            visibility: ["hidden", "visible"],
            transform: [
                `translate(${deltaX}px, ${deltaY}px) scale(${getScales().discard}) rotate(${rotation}deg)`,
            ],
        }, {
            el: ".card-inner",
            transform: [
                "rotateY(-180deg)",
                "rotateY(0deg)",
            ],
        }],
        transitions: [
            { duration: AnimationDuration.FromRoomPlayerHandToDiscard, fill: "forwards", easing: "ease-out" },
            { duration: AnimationDuration.RevealRoomPlayerCards, fill: "forwards" },
        ],
        duration: AnimationDuration.FromRoomPlayerHandToDiscard,
    };
};

export default FromRoomPlayerHandToDiscardAnimation;
